import { useContext } from "react";

import { useDispatch } from "react-redux";
import { useAppSelector } from "../../redux/hooks";
import { setMoveDownPopups } from "../../redux/slices/applicationSlice";

import { MapContext } from "../Map/Map";

import Button from "../Button/Button";
import { useTranslation } from "react-i18next";

interface Props {
  classNames?: string;
  color: "black" | "white";
  outlined?: boolean;
}

export default function MoveDownButton({ classNames, color, outlined }: Props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { onMoveControls, controlTheme } = useContext(MapContext);

  const { moveDownPopups } = useAppSelector((state) => state.application);

  return (
    <Button
      dataQA={moveDownPopups ? "move-up-button" : "move-down-button"}
      onClick={(e) => {
        e.stopPropagation();
        dispatch(setMoveDownPopups(!moveDownPopups));
        onMoveControls();
      }}
      label={
        moveDownPopups
          ? t("move_down_button.raise_controls")
          : t("move_down_button.lower_controls")
      }
      leftIcon={moveDownPopups ? "UpShortArrowIcon" : "DownShortArrowIcon"}
      rounded
      color={color}
      outlined={outlined}
      className={classNames}
      theme={controlTheme}
    />
  );
}
